//This file use only our reference use this variable only once

export class AuthConstants {
    public static readonly AUTH_USERDATA = 'userDataKey';
    public static readonly AUTH_USERROLE = 'userRoleKey';
    //Spot.india mail id
    // public static RazorPay = 'rzp_test_MaWENAaQUwA1XE';
   public static RazorPay = 'rzp_live_ETpK6WecqgeElF'
  
    //spot payment new account settled id
  }